import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withMemo as _withMemo, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-results pb-5 mb-5" }
const _hoisted_2 = { class: "title-big t-blue uppercase text-center mb-5" }

import SelectFilter from "../OrdersView/selectFilter/selectFilter.vue";
import MakeOrder from "./makeOrder/makeOrder.vue";
import { IStore } from "@/store/types/StoreType";
import { computed, ref } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'searchComponent',
  setup(__props) {

const store = useStore<IStore>();

const valueSelectFilter = ref(
  computed<string>(() => store.getters.getSelectFilter)
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$tc("new_orders")), 1),
    _withMemo([valueSelectFilter.value], () => _createVNode(SelectFilter), _cache, 0),
    _createVNode(_component_router_view),
    _createVNode(MakeOrder)
  ]))
}
}

})